import { Spinner } from 'common/Spinner/Spinner'
import Styles from './LoadingState.module.scss'

const LoadingState = () => (
  <div className={Styles.loadingState} aria-label="Loading...">
    <Spinner />
  </div>
)

export { LoadingState }
